import React from 'react'
import { Card, Form, Button, Alert } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import { useInput } from '../hooks/useInput'
import { signInWithEmailAndPassword, signOut} from 'firebase/auth'
import { auth } from '../firebase'
import { useAuth } from '../contexts/authContext'

export default function Login() {
  const [email, onChangeEmail] = useInput()
  const [pswd, onChangePswd] = useInput()
  const user = useAuth()
  const navigate = useNavigate()
  const [error, setError] = React.useState()

  const logOut = async (e)=>{
    setError("")
    await signOut(auth)
  }
  
  const signIn = async (e)=>{
    e.preventDefault()
    try{
      await signInWithEmailAndPassword(auth, email, pswd)
      navigate("/dashboard")
    }

    catch(error){
      if (error.message.indexOf("wrong-password")) setError("Incorrect Password/Email");
      console.log(error.message)
    }
  }

  return (
    <div className="wrapper mt-5 pt-5">
      <Card>
          <Card.Body className=''>
            {user && <Alert variant='success'>{user.email + " Logged In successfully"}</Alert>}
            {error && <Alert variant='warning'>{error}</Alert>}
            <h2 className='text-center my-4'>Admin Log In</h2>
              <Form onSubmit={signIn}>

                <Form.Group className='mb-4'>
                  <Form.Label htmlFor='email'>Email</Form.Label>
                  <Form.Control type='email' value={email} onChange={onChangeEmail} id="email" required disabled = {user && true}></Form.Control>
                </Form.Group>

                <Form.Group>
                  <Form.Label htmlFor='password'>Password</Form.Label>
                  <Form.Control type='password' value={pswd} onChange={onChangePswd} disabled = {user && true} id="password" required></Form.Control>
                </Form.Group>

                {!user ? <Button variant='primary' type='submit' className='my-4'>Log In</Button> : <Button className='my-4' variant='danger' onClick={logOut}>Log Out</Button>}

              </Form>
          </Card.Body>
          <Link to={"/"} className="m-3 h5">HomePage</Link>
      </Card>
    </div>
  )
}
